import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_PLOT_PORTFOLIO_SUBSCRIPTION_BY_ID_PATH,
  GET_PLOT_PORTFOLIO_SUBSCRIPTIONS_PATH,
  GetPlotPortfolioSubscriptionByIdErrorDto,
  GetPlotPortfolioSubscriptionByIdRequestPathVariables,
  GetPlotPortfolioSubscriptionsErrorDto,
  GetPlotPortfolioSubscriptionsRequestQueryParams,
  GetPlotPortfolioSubscriptionsSuccessDto,
  PlotPortfolioSubscription,
} from '@/api/rest/resources/types/plotPortfolioSubscriptions';

type SuccessDto = GetPlotPortfolioSubscriptionsSuccessDto;
type ErrorDto = GetPlotPortfolioSubscriptionsErrorDto;
type QueryParams = GetPlotPortfolioSubscriptionsRequestQueryParams;

export const PLOT_PORTFOLIO_SUBSCRIPTIONS_QUERY_KEY = 'plot-portfolio-subscriptions';

export const usePlotPortfolioSubscriptions = (queryParams?: QueryParams) => {
  const queryFn = async () => {
    return getRequest<SuccessDto, undefined, QueryParams>(
      GET_PLOT_PORTFOLIO_SUBSCRIPTIONS_PATH,
      undefined,
      queryParams,
    );
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: [PLOT_PORTFOLIO_SUBSCRIPTIONS_QUERY_KEY, queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};

export const usePlotPortfolioSubscription = (id: string) => {
  const queryFn = async () => {
    return getRequest<PlotPortfolioSubscription, GetPlotPortfolioSubscriptionByIdRequestPathVariables>(
      GET_PLOT_PORTFOLIO_SUBSCRIPTION_BY_ID_PATH,
      { id },
    );
  };

  return useSuspenseQuery<PlotPortfolioSubscription, GetPlotPortfolioSubscriptionByIdErrorDto>({
    queryKey: [PLOT_PORTFOLIO_SUBSCRIPTIONS_QUERY_KEY, id],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
